module.exports = __webpack_public_path__ + "img/lazio.85248cff.png";